import styled from 'styled-components'

export const Container = styled.div`
  align-items: center;
  height: 48px;
  margin: 5px 30px 0px;
  border-radius: 4px;
`

export const Title = styled.span`
  font-family: 'Inter', Roboto, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
`

export const Subtitle = styled.span`
  font-family: 'Inter', Roboto, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`

export const SubtitleInfo = styled.span`
  font-family: 'Inter', Roboto, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
`
export const Logo = styled.img``
